import { siteName } from "@/constants/config";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        "Do you find yourself holding a pile of Bilt Rewards points and yearning to transform them into your dream vacation? Bilt Rewards points are a valuable asset in the world of travel, offering you the opportunity to transfer these points to esteemed airline partners, thus unlocking the door to remarkable award flights and hotel stays.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "1. Navigate to either the Flights or Hotels tab",
      description:
        "Before you dive into the world of point transfers, it's essential to navigate the landscape of award flight availability using " + siteName + ", a tool that empowers you to search across major airline programs in real-time.",
      img: "https://img.awardtool.com/guides/Bilt1.PNG",
    },
    {
      title: "2. Chose the partner",
      description:
        "You'll find a list of Bilt's transfer partners; please select the one you prefer. After choosing your desired rewards program, you can then enter the number of points you wish to transfer, ensuring that you meet the minimum requirement of 2,000 points for transfers.",
      img: "https://img.awardtool.com/guides/Bilt2.PNG",
    },
    {
      title: "3. Link your loyalty accounts",
      description:
        "If you haven't linked your loyalty accout to your Bilt account, it's time for you to do so.",
      img: "https://img.awardtool.com/guides/Bilt3.PNG",
    },
    {
      title: "4. Transfer your account",
      description:
        "To initiate the transfer, just click on the partner you wish to transfer to.",
      img: "https://img.awardtool.com/guides/Bilt4.PNG",
    },
    {
      title: "5. Book your flight",
      description:
        "Once you've effectively transferred your American Express Membership Rewards points to your chosen airline partner, the last phase involves booking your desired award flight. In order to accomplish this, log in to your airline loyalty account and begin your search for available award flights. To streamline the process and save time, you might want to explore " + siteName + ", a tool that allows you to search for award flights across major airline loyalty programs simultaneously, instead of having to visit each airline's website separately.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    },
    {
      // title: "5. Is your information transferred internationally?",
      description:
        "Keep in mind that award flight availability can vary, so it's wise to begin your search well in advance of your intended travel date. For added assurance, confirm the availability of your desired award flight directly on the airline's website before initiating the transfer of your American Express Membership Rewards points. Remember, point transfers are irreversible, so meticulous planning is key.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.png",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
